import React, { Component } from "react";
import { connect } from "react-redux";
import LangContext, { i18n } from "modules/shared/context/langContext";
import * as actions from "../actions";
import { GeneralStyledContent } from "../../../../styled/common-styled";
import Breadcrumb from "./../../../shared/components/Breadcrumb";
import {
  Button,
  Row,
  Col,
  Icon,
  Drawer,
  message,
  Pagination,
  Tooltip,
  Badge,
  Input,
} from "antd";
import Filter from "./Filter";
import { TableStyled } from "./StyleComponent";

import RescheduleLog from "./RescheduleLog";
import FilterModal from "./FilterModal";

const columnStyle = { fontSize: "12px", fontWeight: "400" };
const { Search } = Input;
class Index extends Component {
  state = {
    visible: false,
    page: 1,
    pageSize: 20,
    searchName: "",
    orderBy: "id",
    orderType: "asc",
    filterObj: {
      plate_no: "",
      code: "",
      device_user: "",
      vehicle_type: "",
      maintenance_status: "",
      type: "",
      location_code: "",
      zone: "",
      closed_in_30days: false,
      searchInput: "",
    },

    // modal reschedule log
    rescheduleLogVisible: false,
    rescheduleLogData: [],

    //modal filter
    visible_filter_modal: false,

    process_color: {
      o: "#1890ff", // open
      s: "#1890ff", //schedule
      cf: "green", // closed fixed
      cn: "red", // closed not available
      ot: "red", // cancel
      wa: "#1890ff", // waiting assessment
      ws: "#1890ff", // waiting scheduled
      ps: "#1890ff", // pending signature
    },

    isFilter: false, // ใช้สำหรับ badge แสดงว่ามีการกรองข้อมูลหรือไม่
  };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onCloseSearch = (resetForm) => {
    this.setState({
      visible: false,
    });
  };

  filterServicerepairdevice = (values) => {
    const {
      plate_no,
      code,
      device_user,
      vehicle_type,
      maintenance_status,
      type,
      location_code,
      zone,
      closed_in_30days,
    } = values;

    let isFilter = false;
    if (
      plate_no ||
      code ||
      device_user ||
      vehicle_type ||
      maintenance_status ||
      type ||
      location_code ||
      zone ||
      closed_in_30days
    ) {
      isFilter = true;
    }

    this.setState(
      {
        filterObj: {
          ...this.state.filterObj,
          plate_no: plate_no,
          code: code,
          device_user: device_user,
          vehicle_type: vehicle_type,
          maintenance_status: maintenance_status,
          type: type,
          location_code: location_code,
          zone: zone,
          closed_in_30days: closed_in_30days,
        },
        page: 1,
        isFilter: isFilter, // อัพเดตสถานะการกรองข้อมูล
      },
      () => {
        this.handleCloseFilterModal();
        this.onFilterButtonClick();
      }
    );
  };

  componentDidMount() {
    this.props.loadServicerepairdevice(this.state, true);
  }

  componentDidUpdate(prevProps, prevState) {
    const { dataResponse } = this.props.servicerepairdevice;

    if (dataResponse.action_type == "create") {
      if (dataResponse.status == "success") {
        message.info("สำเร็จ");
      } else if (dataResponse.status == "fail") {
        message.info("ไม่สำเร็จ");
      }
      this.props.clearDataResponse();
    }
  }

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      page: 1,
    });

    let orderBy = "";
    let orderType = "";

    if (Object.keys(sorter).length === 0 && sorter.constructor === Object) {
      orderBy = this.state.orderBy;
      orderType = this.state.orderType;
    } else {
      this.setState({
        orderBy: sorter.columnKey,
        orderType: sorter.order == "descend" ? "desc" : "asc",
      });
      orderBy = sorter.columnKey;
      orderType = sorter.order == "descend" ? "desc" : "asc";
    }

    this.props.loadServicerepairdevice(
      {
        page: this.state.page,
        pageSize: this.state.pageSize,
        searchName: "",
        orderBy: orderBy,
        orderType: orderType,
        filterObj: {
          ...this.state.filterObj,
        },
      },
      true
    );
  };

  handleFilterObjSearchInput = (e) => {
    const {
      plate_no,
      code,
      device_user,
      vehicle_type,
      maintenance_status,
      type,
      location_code,
      zone,
    } = this.state.filterObj;
    let isFilter = false;
    if (
      plate_no ||
      code ||
      device_user ||
      vehicle_type ||
      maintenance_status ||
      type ||
      location_code ||
      zone ||
      e.target.value
    ) {
      isFilter = true;
    }

    this.setState({
      filterObj: {
        ...this.state.filterObj,
        searchInput: e.target.value,
      },
      isFilter: isFilter, // อัพเดตสถานะการกรองข้อมูล
    });
  };

  onFilterButtonClick = () => {
    this.props.loadServicerepairdevice(
      {
        page: this.state.page,
        pageSize: this.state.pageSize,
        searchName: this.state.searchName,
        orderBy: this.state.orderBy,
        orderType: this.state.orderType,
        filterObj: {
          ...this.state.filterObj,
        },
      },
      true
    );
  };
  handleEnterSearchInput = (e) => {
    this.setState(
      {
        page: 1,
      },
      () => {
        this.onFilterButtonClick();
      }
    );
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return true;
  }

  handleOpenRescheduleLog = (data) => {
    this.setState({
      rescheduleLogVisible: true,
      rescheduleLogData: data,
    });
  };
  handleCloseRescheduleLog = () => {
    this.setState({
      rescheduleLogVisible: false,
      rescheduleLogData: [],
    });
  };

  handleOpenFilterModal = () => {
    this.setState({
      visible_filter_modal: true,
    });
  };

  handleCloseFilterModal = () => {
    this.setState({
      visible_filter_modal: false,
    });
  };

  render() {
    let self = this;
    const columns = [
      {
        title: "#",
        dataIndex: "row_number",
        width: 60,
        fixed: "left",
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.v.vehicle}
          </LangContext.Consumer>
        ),
        key: "plate_no",
        dataIndex: "plate_no",
        sorter: true,
        width: 300,
        fixed: "left",
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <div>{`${record.plate_no || "-"} (${record.code || "-"})`}</div>
            ),
          };
        },
      },
      /*
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.d.driverName}
          </LangContext.Consumer>
        ),
        key: "firstname",
        dataIndex: "device_user",
        sorter: true,
        width: 200,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.v.vehicle_type}
          </LangContext.Consumer>
        ),
        key: "vehicle_type",
        dataIndex: "vehicle_type",
        sorter: true,
        width: 200,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },*/
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.l.lastest_signal}
          </LangContext.Consumer>
        ),
        key: "latest_pos_update_at",
        dataIndex: "latest_pos_update_at",
        sorter: true,
        width: 150,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <div
                style={{
                  color: record.latest_pos_update_at_color || "black",
                }}
              >
                {text}
              </div>
            ),
          };
        },
      },
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.g.gps_update}
          </LangContext.Consumer>
        ),
        key: "latest_position",
        dataIndex: "latest_position",
        sorter: true,
        width: 170,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.m.maintenance_type}
          </LangContext.Consumer>
        ),
        key: "type_name_th",
        dataIndex: "type_name_th",
        sorter: true,
        width: 80,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          // วันเวลาที่แจ้งซ่อม
          <LangContext.Consumer>
            {(i18n) => i18n.m.maintenanceDeviceReceiveDate}
          </LangContext.Consumer>
        ),
        key: "receive_date",
        dataIndex: "receive_date",
        sorter: true,
        width: 130,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          // วันเวลาที่นัดหมาย
          <LangContext.Consumer>
            {(i18n) => i18n.a.appointment_date}
          </LangContext.Consumer>
        ),
        key: "appointment_date",
        dataIndex: "appointment_date",
        sorter: true,
        width: 150,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.m.maintenance_status}
          </LangContext.Consumer>
        ),
        dataIndex: "",
        sorter: false,
        render(text, record, index) {
          let message = "";
          let link_path = "";
          let link_check = false;
          let color_message = "";
          if (record.lost_device == 0) {
            if (record.device_code != "-") {
              if (record.process_type === null) {
                message = "-";
                color_message = "black";
              } else {
                message = record.status_name_th;
                color_message =
                  self.state.process_color[record.process_type.toLowerCase()];
              }
            } else {
              message = "ยังไม่ได้ติดตั้ง";
              color_message = "red";
            }
          } else if (record.online == 0) {
            message = "อุปกรณ์หาย";
            color_message = "red";
          }

          return {
            props: {
              style: columnStyle,
            },

            children: <span style={{ color: color_message }}>{message}</span>,
          };
        },
        width: 100,
      },
      {
        title: (
          // อาการของปัญหา
          <LangContext.Consumer>
            {(i18n) => i18n.t.type_problem}
          </LangContext.Consumer>
        ),
        key: "type_problem",
        dataIndex: "type_problem",
        sorter: false,
        width: 300,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <div>
                {record.type_problem == 6 ? ( // อื่นๆ
                  <span>{record.detail_problem}</span>
                ) : (
                  <span>{record.type_problem_name}</span>
                )}
              </div>
            ),
          };
        },
      },
      {
        title: (
          // รายละเอียดเพิ่มเติม
          <LangContext.Consumer>
            {(i18n) => i18n.m.moreDetails}
          </LangContext.Consumer>
        ),
        key: "comment",
        dataIndex: "comment",
        sorter: false,
        width: 300,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      /*
      {
        title: (
          // วันเวลาปฏิบัติงาน
          <LangContext.Consumer>
            {(i18n) => i18n.w.work_date}
          </LangContext.Consumer>
        ),
        key: "work_date",
        dataIndex: "work_date",
        sorter: true,
        width: 150,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          // การแก้ไขปัญหา
          <LangContext.Consumer>
            {(i18n) => i18n.e.editProblem}
          </LangContext.Consumer>
        ),
        key: "edit_problem",
        dataIndex: "edit_problem",
        sorter: false,
        width: 300,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <div>
                {record.edit_problem.map((item, index) => {
                  return (
                    <div key={index}>
                      {item.edit_problem_id == 21 ? ( //อิื่นๆ
                        <span>{`-${item.detail_amount_devicecode || ""}`}</span>
                      ) : (
                        <span>{`-${item.master_name} ${item.detail_amount_devicecode}`}</span>
                      )}
                    </div>
                  );
                })}
              </div>
            ),
          };
        },
      },
      */
      {
        title: (
          // วันที่ปิดงานล่าสุด
          <LangContext.Consumer>
            {(i18n) => i18n.l.latestFinishDate}
          </LangContext.Consumer>
        ),
        key: "latest_finish_date",
        dataIndex: "latest_finish_date",
        sorter: false,
        width: 150,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        //ชื่อผู้ยื่นเรื่อง
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.s.submit_name}
          </LangContext.Consumer>
        ),
        key: "submit_name",
        dataIndex: "submit_name",
        width: 200,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.r.rescheduleLog}
          </LangContext.Consumer>
        ),
        key: "reschedule_log",
        dataIndex: "reschedule_log",
        width: 130,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <Button
                size="small"
                onClick={() => {
                  self.handleOpenRescheduleLog(record.reschedule_log || []);
                }}
                type="link"
                style={{
                  fontSize: "12px",
                  padding: "0px",
                }}
                disabled={record.reschedule_log.length == 0}
              >
                <LangContext.Consumer>
                  {(i18n) => i18n.r.rescheduleLog}
                </LangContext.Consumer>
              </Button>
            ),
          };
        },
      },
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.t.technician_name}
          </LangContext.Consumer>
        ),
        key: "technician_name",
        dataIndex: "technician_name",
        width: 120,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          <LangContext.Consumer>
            {(i18n) => i18n.t.technician_telno}
          </LangContext.Consumer>
        ),
        key: "technician_telno",
        dataIndex: "technician_telno",
        width: 120,
        sorter: false,
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: (
          <LangContext.Consumer>{(i18n) => i18n.a.action}</LangContext.Consumer>
        ),
        dataIndex: "",
        sorter: false,
        width: 130,
        fixed: "right",
        render(text, record, index) {
          return {
            props: {
              style: columnStyle,
            },
            children: (
              <LangContext.Consumer>
                {(i18n) => (
                  <div>
                    {/* ปุ่มแจ้งซ่อม */}
                    <a
                      href={`/servicerepairdevice/create/${record.id}/${record.companies_id}`}
                      style={{
                        padding: "0px 10px 0px 0px",
                        fontSize: "12px",
                      }}
                      disabled={record.process_type === null ? false : true}
                    >
                      <span
                        style={{
                          color:
                            record.process_type === null ? "green" : "gray",
                        }}
                      >
                        {i18n.m.maintenanceAndUninstallDevice}
                      </span>
                    </a>

                    {/* รายละเอียดสถานะใบงาน */}
                    <a
                      href={`/servicerepairdevice/historys/${record.id}`}
                      style={{ padding: "0px", fontSize: "12px" }}
                    >
                      {i18n.h.history_servicerepairdevice}
                    </a>
                  </div>
                )}
              </LangContext.Consumer>
            ),
          };
        },
      },
    ];

    return (
      <GeneralStyledContent>
        <Row gutter={24}>
          <Col span={24}>
            <Breadcrumb
              match={this.props.match}
              style={{ margin: "0px 0px 14px 10px" }}
            />
          </Col>
        </Row>
        <Row gutter={[8, 8]} type="flex" justify="end">
          <Col span={12}>
            <span style={{ color: "red" }}>
              {" "}
              *หมายเหตุ:กรณีที่อุปกรณ์หายให้ติดต่อกับฝ่ายขาย
            </span>
          </Col>

          {/* <Col span={2} align="right">
            <Button icon="filter" size="small" onClick={this.showDrawer}>
              <LangContext.Consumer>
                {(i18n) => i18n.f.filter}
              </LangContext.Consumer>
            </Button>
          </Col> */}

          <Col span={12} align="right">
            {/* รวม filter ในช่อง input เดียว */}
            <Search
              placeholder={`${i18n[this.props.language].s.search}${
                i18n[this.props.language].v.vehicle
              }, ${i18n[this.props.language].d.driver}, ${
                i18n[this.props.language].p.plantCode
              }`}
              style={{ width: "60%" }}
              value={this.state.filterObj.searchInput}
              onChange={this.handleFilterObjSearchInput}
              onSearch={this.handleEnterSearchInput}
              onPressEnter={this.handleEnterSearchInput}
            />

            <Badge dot={this.state.isFilter} align="right">
              <Tooltip
                placement="left"
                title={
                  <LangContext.Consumer>
                    {(i18n) => i18n.o.openFilter}
                  </LangContext.Consumer>
                }
              >
                <Button
                  type="primary"
                  icon="filter"
                  style={{ marginLeft: "5px" }}
                  onClick={this.handleOpenFilterModal}
                ></Button>
              </Tooltip>
            </Badge>
          </Col>

          <Col span={24}>
            <TableStyled
              bordered
              size="small"
              scroll={{ x: 1500, y: false }}
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={
                this.props.servicerepairdevice.servicerepairdeviceLists
              }
              pagination={false}
              loading={
                this.props.servicerepairdevice.servicerepairdeviceLoading
              }
              onChange={this.handleTableChange}
            />
          </Col>
          <Col span={24} align="right">
            <Pagination
              size="small"
              showSizeChanger
              defaultCurrent={1}
              pageSize={this.state.pageSize}
              current={this.state.page}
              pageSizeOptions={["10", "20", "30", "40", "50"]}
              onChange={(page, pageSize) => {
                this.setState(
                  {
                    page,
                    pageSize,
                  },
                  () => {
                    this.props.loadServicerepairdevice(
                      {
                        page,
                        pageSize,
                        searchName: this.state.searchName,
                        orderBy: this.state.orderBy,
                        orderType: this.state.orderType,
                        filterObj: {
                          ...this.state.filterObj,
                        },
                      },
                      true
                    );
                  }
                );
              }}
              onShowSizeChange={(current, size) => {
                this.setState(
                  {
                    page: 1,
                    pageSize: size,
                  },
                  () => {
                    this.props.loadServicerepairdevice(
                      {
                        page: 1,
                        pageSize: size,
                        searchName: this.state.searchName,
                        orderBy: this.state.orderBy,
                        orderType: this.state.orderType,
                        filterObj: {
                          ...this.state.filterObj,
                        },
                      },
                      true
                    );
                  }
                );
              }}
              total={this.props.servicerepairdevice.servicerepairdeviceTotal}
            />
          </Col>
        </Row>
        {/* <LangContext.Consumer>
          {(i18n) => (
            <Drawer
              title={i18n.s.search}
              width={350}
              onClose={this.onCloseSearch}
              visible={this.state.visible}
            >
              <Filter
                OnClose={this.onCloseSearch}
                onSubmit={this.filterServicerepairdevice}
                loadMaintenancestatus={this.props.loadMaintenancestatus}
                loadMaintenancetype={this.props.loadMaintenancetype}
                loadVehicletype={this.props.loadVehicletype}
                loadZone={this.props.loadZone}
                maintenancetypeLists={
                  this.props.servicerepairdevice.maintenancetypeLists
                }
                zoneLists={this.props.servicerepairdevice.zoneLists}
                maintenancestatusLists={
                  this.props.servicerepairdevice.maintenancestatusLists
                }
                vehicletypeLists={
                  this.props.servicerepairdevice.vehicletypeLists
                }
              />
            </Drawer>
          )}
        </LangContext.Consumer> */}

        {/* modal แสดงประวัติการเลื่อนนัด */}
        <RescheduleLog
          visible={this.state.rescheduleLogVisible}
          handleModalCancel={this.handleCloseRescheduleLog}
          data={this.state.rescheduleLogData}
        />

        {/* modal filter */}
        <FilterModal
          visible={this.state.visible_filter_modal}
          handleCancel={this.handleCloseFilterModal}
          handleSubmitSearch={this.filterServicerepairdevice}
          filterObj={this.state.filterObj}
          loadMaintenancestatus={this.props.loadMaintenancestatus}
          loadMaintenancetype={this.props.loadMaintenancetype}
          loadVehicletype={this.props.loadVehicletype}
          loadZone={this.props.loadZone}
          maintenancetypeLists={
            this.props.servicerepairdevice.maintenancetypeLists
          }
          zoneLists={this.props.servicerepairdevice.zoneLists}
          maintenancestatusLists={
            this.props.servicerepairdevice.maintenancestatusLists
          }
          vehicletypeLists={this.props.servicerepairdevice.vehicletypeLists}
        />
      </GeneralStyledContent>
    );
  }
}

const mapStateToProps = ({
  servicerepairdevice,
  auth: { profile },
  ui: { language },
}) => ({
  servicerepairdevice,
  profile,
  language,
});

const mapDispatchToProps = {
  loadServicerepairdevice: actions.loadServicerepairdevice.request,
  loadMaintenancestatus: actions.loadMaintenancestatus.request,
  loadMaintenancetype: actions.loadMaintenancetype.request,
  loadZone: actions.loadZone.request,
  loadVehicletype: actions.loadVehicletype.request,
  clearDataResponse: actions.clearDataResponse,
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
